import { api } from '../../../api/client.js';

/**
 * @param {string} slug
 * @param {File} file
 */
export async function parseStoreDocumentOrderFile(slug, file) {
  const fd = new FormData();
  fd.append('file', file);
  return api(`/store/${encodeURIComponent(slug)}/document-order/parse`, {
    method: 'POST',
    body: fd,
    skipAuth: true,
  });
}

/**
 * @param {string} slug
 * @param {{ sessionId?: string | null, file?: File | null }} opts
 */
export async function parseStoreDocumentOrderWithAi(slug, opts) {
  const { sessionId, file } = opts;
  if (file) {
    const fd = new FormData();
    fd.append('file', file);
    if (sessionId) fd.append('session_id', sessionId);
    return api(`/store/${encodeURIComponent(slug)}/document-order/parse-ai`, {
      method: 'POST',
      body: fd,
      skipAuth: true,
    });
  }
  return api(`/store/${encodeURIComponent(slug)}/document-order/parse-ai`, {
    method: 'POST',
    body: JSON.stringify({ session_id: sessionId || '' }),
    skipAuth: true,
  });
}
